import { dateToISOWithoutTimezone, useTranslations } from "@jugl-web/utils";
import {
  InteractiveContainer,
  Popover,
} from "@jugl-web/ui-components/cross-platform";
import { DatePicker } from "@jugl-web/ui-components/cross-platform/DatePicker";
import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";
import format from "date-fns/format";
import { ReactComponent as CalendarIcon } from "./assets/calendar.svg";

export const IssueDateField = () => {
  const { formValues, setFieldValue } = useInvoicesItemFormPageContext();
  const { t } = useTranslations();

  const onChange = (date: Date | null) => {
    if (!date) {
      setFieldValue("date", "");
      return;
    }
    setFieldValue("date", dateToISOWithoutTimezone(date));
  };

  const date = formValues.date || null;

  return (
    <div>
      <Popover
        className="w-[340px] rounded-xl"
        placement="bottom-start"
        renderTrigger={({ Trigger, triggerRef }) => (
          <Trigger ref={triggerRef} as={InteractiveContainer}>
            <label className="mb-2 block pl-2.5 font-secondary text-[15px] font-normal text-dark-700">
              {t({
                id: "invoices.item.issueDate",
                defaultMessage: "Issue date",
              })}
            </label>

            <InteractiveContainer className="flex h-[57px] w-full items-center justify-between rounded-xl border border-solid border-grey-400 px-4 text-base outline-none">
              <span className={date ? "text-[#363636]" : "text-dark-500"}>
                {date ? format(new Date(date), "dd MMM yyyy") : "DD/MM/YYYY"}
              </span>
              <CalendarIcon />
            </InteractiveContainer>
          </Trigger>
        )}
      >
        {({ onClose }) => (
          <DatePicker
            onSubmit={onChange}
            initialDate={date ? new Date(date) : undefined}
            onClose={onClose}
            className="p-4"
            showCancelButton
          />
        )}
      </Popover>
    </div>
  );
};
